/* eslint-disable no-console */

import { register } from 'register-service-worker'
import { appNotifications } from '@/services/notification.app'

export function registerServiceWorker(): void {
  if (process.env.NODE_ENV === 'production') {
    register(`${process.env.BASE_URL}service-worker.js`, {
      ready() {
        console.log(
          'App is being served from cache by a service worker.\n' +
            'For more details, visit https://goo.gl/AFskqB',
        )
      },
      registered() {
        console.log('Service worker has been registered.')
      },
      cached() {
        console.log('Content has been cached for offline use.')
      },
      updatefound() {
        console.log('New content is downloading.')
      },
      updated() {
        // Show notification to inform the user about app update
        // and allow them refresh the app
        appNotifications.unique({
          title: 'Update is Available.',
          message: 'Please refresh to get the latest version.',
          dismissible: false,
          actions: [
            {
              label: 'Refresh',
              onClick: (): void => {
                window.location.reload()
              },
            },
          ],
        })
      },
      offline() {
        console.log(
          'No internet connection found. App is running in offline mode.',
        )
      },
      error(error) {
        console.error('Error during service worker registration:', error)
      },
    })
  }
}
